import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import {PermissionsService} from "../permissions/permissions.service";
import { PlanService } from '../plan-status/plan-status.service';
@Injectable()
export class SendXrefPermissionGuardService {

  constructor(private permission: PermissionsService) {
  }

  canActivate(route: ActivatedRouteSnapshot) {
    let canActivate = false;
    let canSendReferenceRequest = this.permission.hasPermission('can_send_reference_requests') || this.permission.hasPermission('can_send_reference_requests_with_survey_perms');
    let canSendPulseRequest = this.permission.hasPermission('can_send_pulse_requests') || this.permission.hasPermission('can_send_pulse_requests_with_survey_perms');
    let canSendExitRequest = this.permission.hasPermission('can_send_exit_requests') || this.permission.hasPermission('can_send_exit_requests_with_survey_perms');
    let canSendBackgroundRequest = this.permission.hasPermission('can_send_backgroundcheck_requests');

    canActivate = canSendReferenceRequest || canSendPulseRequest || canSendExitRequest || canSendBackgroundRequest;
    return canActivate;
  }
}

@Injectable()
export class PaymentCanActivateGuardService {

  constructor(private router:Router, private planservice:PlanService, private permissions:PermissionsService) { }

  canActivate(){
    const state = this.planservice.getGuard()
    if(state===false){
      this.router.navigate(['requests'])
      return false
    }else{
      return true
    }
  }
}
